import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260220_unify_view_filter_types",
  description: "Unify view filter types: stair → stairSystems",
  apply(json: any) {
    json.planViews = json.planViews ?? {};
    for (const id of Object.keys(json.planViews)) {
      migrateViewFilterPlan(json.planViews[id].viewFilter);
    }
    json.view3Ds = json.view3Ds ?? {};
    for (const id of Object.keys(json.view3Ds)) {
      migrateViewFilter3D(json.view3Ds[id].viewFilter);
    }
    json.elevationViews = json.elevationViews ?? {};
    for (const id of Object.keys(json.elevationViews)) {
      migrateViewFilter3D(json.elevationViews[id].viewFilter);
    }
    json.sectionViews = json.sectionViews ?? {};
    for (const id of Object.keys(json.sectionViews)) {
      migrateViewFilter3D(json.sectionViews[id].viewFilter);
    }
    return json;
  },
};

/** Plan views: overwrite stairSystems with old field stair. */
function migrateViewFilterPlan(viewFilter: any) {
  if (viewFilter === undefined) {
    return;
  }
  if (viewFilter.stair !== undefined) {
    viewFilter.stairSystems = viewFilter.stair;
    delete viewFilter.stair;
  }
}

/** 3D, elevation, section views: delete outdated field stair. */
function migrateViewFilter3D(viewFilter: any) {
  if (viewFilter === undefined) {
    return;
  }
  if (viewFilter.stair !== undefined) {
    delete viewFilter.stair;
  }
}

export default migration;
